import { matchPath } from 'react-router-dom';

export const PANTALLA_VISIBLE = 'VISIBLE';
export const PANTALLA_OCULTA = 'OCULTA';
export const PANTALLA_SIN_REGISTRAR = 'SIN_REGISTRAR';

// Panel de administración de la visibilidad: no está en la tabla a propósito,
// para que ningún cambio de la tabla pueda dejar a la administradora sin él.
// Solo lo enseña el menú a ADMIN y el backend exige ADMIN en sus endpoints.
export const RUTA_PANEL_PANTALLAS = '/dashboard/pantallas';
// Igual de excluida de la tabla: alta y gestión de usuarios, solo ADMIN.
export const RUTA_ALTA_USUARIO = '/dashboard/alta-usuario';

// `pantallas` es la lista de la API: [{ nombre, url, visible }], donde `url` es
// un patrón de React Router ('/jornadas/:id'). `null` = no se pudo cargar: se
// deja pasar (es visibilidad de interfaz, no seguridad; los datos los protege
// el backend). Una ruta que no esté en la tabla es una pantalla nueva sin dar
// de alta: queda tapada hasta que el administrador la registre.
export function estadoPantalla(pantallas, pathname) {
  if (!pantallas || pathname === RUTA_PANEL_PANTALLAS || pathname === RUTA_ALTA_USUARIO) return PANTALLA_VISIBLE;
  const pantalla = pantallas.find((p) => matchPath({ path: p.url, end: true }, pathname));
  if (!pantalla) return PANTALLA_SIN_REGISTRAR;
  return pantalla.visible ? PANTALLA_VISIBLE : PANTALLA_OCULTA;
}

export const esPantallaVisible = (pantallas, pathname) =>
  estadoPantalla(pantallas, pathname) === PANTALLA_VISIBLE;
